import React, { useCallback, useEffect, useState } from 'react'
import { Button, Spin, Modal, Form, Input, InputNumber, Space } from 'antd'
import ImageListUpload from '../../ImageListUpload'
import { removeFile } from '../../../services/upload'

const { TextArea } = Input

const EquipmentFormModal = ({
  equipment = {},
  showModal,
  isFetching,
  onCancel,
  onFinish,
  onError,
  modalTitle,
  formName,
  submitCaption,
}) => {
  const [form] = Form.useForm()

  let [images, setImages] = useState([])

  useEffect(() => {
    if (equipment) {
      form.setFieldsValue({ ...equipment })
      if (equipment.images) setImages(equipment.images)
    }
  }, [equipment])

  const clear = () => {
    form.resetFields()
    setImages([])
  }

  const compileImages = (images) => images.map(({ fileId }) => fileId)

  const onCancelClick = () => {
    onCancel()
    removeOrphanImages()
    clear()
  }

  const removeOrphanImages = () => {
    let srcFileIds = equipment && equipment.images ? equipment.images.map((f) => f.fileId) : []
    for (let imageId of compileImages(images)) {
      if (!srcFileIds.includes(imageId)) removeFile(imageId)
    }
  }

  const onFinishCallback = useCallback(
    async (data) => {
      try {
        await onFinish({ ...data, images: compileImages(images) })
        clear()
      } catch (err) {
        onError(err.error)
      }
    },
    [onFinish, images]
  )

  return (
    <Modal
      title={modalTitle}
      visible={showModal}
      onCancel={onCancelClick}
      footer={[
        <Button key="back" onClick={onCancelClick}>
          Отмена
        </Button>,
        <Button key="save" type="primary" onClick={() => form.submit()}>
          {submitCaption}
        </Button>,
      ]}
    >
      <Spin spinning={isFetching}>
        <Form
          name={formName}
          autoComplete="off"
          layout="horizontal"
          onFinish={onFinishCallback}
          form={form}
          size="large"
        >
          <Form.Item
            name="name"
            label="Наименование оборудования"
            labelCol={{ span: 24 }}
            rules={[{ required: true, message: 'Поле обязательно' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="serial_number" label="Серийный номер" labelCol={{ span: 24 }}>
            <Input />
          </Form.Item>
          <Space>
            <Form.Item name="issue_year" label="Год выпуска" labelCol={{ span: 24 }}>
              <InputNumber min={1900} max={new Date().getFullYear()} />
            </Form.Item>
            <Form.Item name="price" label="Цена" labelCol={{ span: 24 }}>
              <InputNumber style={{ width: 120 }} />
            </Form.Item>
          </Space>
          <Form.Item name="description" label="Описание оборудования" labelCol={{ span: 24 }}>
            <TextArea rows={4} />
          </Form.Item>
        </Form>
        <ImageListUpload images={images} onImageListChange={setImages} />
      </Spin>
    </Modal>
  )
}

export default EquipmentFormModal
